import {ReactElement} from "react";
import {useParams} from "react-router-dom";

import ContentOnglet from "@/components/ContentOnglet/ContentOnglet";

function FournisseurDetail(): ReactElement {
  const {id} = useParams();
  return (
    <ContentOnglet title="fournisseur de test">
      <div>fournisseur à l'id {id}</div>
    </ContentOnglet>
  );
}

export default FournisseurDetail;
